<template>
  <div
    class="title-and-clear-all"
  >
    <header class="left-title">
      <h2 class="text-body-1 text-textDarkest">
        Filters
      </h2>
      <FilterInfoTooltip
        v-if="tooltip.body_r"
        :tooltip="tooltip"
        :tooltip-offset="0"
        :multiple-tooltip-offsets="{
          mainAxis: 12,
          crossAxis: 20,
        }"
        max-width="476px"
        class="ml-1"
      />
    </header>
    <button
      type="button"
      class="clear-all"
      :class="[!areFiltersApplied ? 'text-textLight' : 'text-primary']"
      :disabled="!areFiltersApplied"
      @click="emit('clearFilters', { router: $router })"
    >
      Clear All
    </button>
  </div>
</template>

<script setup>
import FilterInfoTooltip from '@/components/filter/FilterInfoTooltip.vue';

defineProps({
  areFiltersApplied: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['clearFilters']);
</script>

<style lang="less" scoped>
.title-and-clear-all {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 500;
  padding: 0 8px;

  .left-title {
    display: flex;
    align-items: center;

    p {
      margin-right: 4px;
    }
  }

  .clear-all {
    &[disabled] {
      cursor: default;
    }
  }
}
</style>
